const lightTheme = {
  text: '#4A4A4A',
  textSubtitle: '#6d6d6d',
  textStrong: '#333333',
  textDisabled: '#33333361',
  primaryText: '#5C8211',
  secondaryText: '#004461',
  dangerText: '#bf2029',
  warningText: '#a78500',
  linkText: '#0073a5',
  successText: '#5C8211',
  successDark: '#425A13',
  linkTextPressed: '#004461',
  linkTextHover: '#1e92c5',
  onprimaryText: '#ffffff',
  onsecondaryText: '#ffffff',
  textInverse: '#ffffff',
  bg: '#ffffff',
  bgMedium: '#F9FAFB',
  bgStrong: '#EDF0F2',
  bgDark: '#303030',
  bgDisabled: '#EDF0F2',
  bgSelected: '#B1B4A9',
  primaryBgTint: '#F3F8E6',
  primaryBgSubtle: '#C1DE7F',
  primaryBg: '#9aca3c',
  secondaryBgTint: '#f5fafc',
  secondaryBgSubtle: '#cae5f1',
  secondaryBg: '#0073a5',
  tertiaryBg: '#005572',
  dangerBgSubtle: '#f1c9d1',
  dangerBg: '#bf2029',
  warningBgSubtle: '#e3d393',
  warningBg: '#ED6C02',
  contrastBg: '#3d4133',
  heroProductsBg: '#4a7694',
  heroSolutionsBg: '#0073a5',
  heroResourcesBg: '#007f95',
  heroCompanyBg: '#5c8211',
  heroSupportBg: '#206978',
  heroWhyyubicoBg: '#3c72b1',
  primaryBtn: '#84BD00',
  primaryBtnHover: '#add165',
  primaryBtnPressed: '#5c8013',
  secondaryBtn: '#0073a5',
  secondaryBtnHover: '#6a9bc0',
  secondaryBtnPressed: '#165071',
  dangerBtn: '#bf2029',
  dangerBtnHover: '#db6e63',
  dangerBtnPressed: '#831f1f',
  warningBtn: '#a78500',
  warningBtnHover: '#c5a85b',
  warningBtnPressed: '#725b0e',
  onprimaryBtn: '#ffffff',
  onprimaryBtnHover: '#F3F8E6',
  btnDisabled: '#D8D8D8',
  btnInverse: '#ffffff4d',
  border: '#D8D8D8',
  borderSubtle: '#EDF0F2',
  borderStrong: '#939292',
  primaryBorderSubtle: '#C1DE7F',
  secondaryBorder: '#0073a5',
  secondaryBorderSubtle: '#cae5f1',
  dangerBorder: '#bf2029',
  warningBorder: '#a78500',
  borderFocus: '#9aca3c',
  icon: '#939292',
  iconStrong: '#4A4A4A',
  primaryIcon: '#84BD00',
  secondaryIcon: '#0073a5',
  tertiaryIcon: '#005572',
  warningIcon: '#a78500',
  dangerIcon: '#bf2029',
  infoIcon: '#0073a5',
  successIcon: '#5C8211',
  iconHover: '#D8D8D8',
  iconPressed: '#6d6d6d',
  iconStrongHover: '#6d6d6d',
  iconStrongPressed: '#333333',
  iconDisabled: '#D8D8D8',
  onprimaryIcon: '#ffffff',
  iconInverse: '#ffffff',
  yubiGreen: '#9aca3c',
  yubiBlue: '#325f74',
  yubiGold: '#e7c040',
  yubiRed: '#bf2029',
  yubiBrightblue: '#0080AC',
  yubiLightblue: '#83B9D6',
  yubiDarkgray: '#676767',
  YubiLightgray: '#939292',
  hotpink30: '#ff00b24d',
  sysPrimaryContrast: '#ffffff',
  sysPrimaryTint: '#F3F8E6',
  sysPrimaryLight: '#C1DE7F',
  sysPrimaryMain: '#9aca3c',
  sysPrimaryMedium: '#84BD00',
  sysPrimaryDark: '#5C8211',
  sysSecondaryTint: '#f5fafc',
  sysSecondaryLight: '#cae5f1',
  sysSecondaryMain: '#0073a5',
  sysSecondaryDark: '#004461',
  sysSecondaryContrast: '#ffffff',
  sysTertiaryStrong: '#005572',
  sysSuccessSubtle: '#C1DE7F',
  sysSuccessDefault: '#5C8211',
  sysSuccessContrast: '#ffffff',
  sysInfoSubtle: '#cae5f1',
  sysInfoDefault: '#0073a5',
  sysDangerSubtle: '#f1c9d1',
  sysDangerDefault: '#bf2029',
  sysWarningSubtle: '#e3d393',
  sysWarningDefault: '#a78500',
  sysNeutral0: '#ffffff',
  sysNeutral1: '#F9FAFB',
  sysNeutral2: '#EDF0F2',
  sysNeutral3: '#D8D8D8',
  sysNeutral4: '#939292',
  sysNeutral5: '#6d6d6d',
  sysNeutral6: '#4A4A4A',
  sysNeutral7: '#333333',
  sysNeutralAlt6: '#686f59',
  sysNeutralAlt7: '#3d4133',
  sysBrandYubiGreen: '#9aca3c',
  sysBrandYubiBlue: '#325f74',
  sysBrandYubiGold: '#e7c040',
  sysBrandYubiRed: '#bf2029',
  sysBrandYubiBrightblue: '#0080AC',
  sysBrandYubiLightblue: '#83B9D6',
  sysBrandYubiDarkgray: '#676767',
  sysBrandYubiLightgray: '#939292',
  sysMixratioPressed: '0.3',
  sysMixratioHover: '0.3',
  inputStandardEnabledBorder: '#0000006b',
  inputStandardHoverBorder: '#000000',
  inputFilledEnabledFill: '#0000000f',
  inputFilledHoverFill: '#00000017',
  inputOutlinedEnabledBorder: '#0000003b',
  inputOutlinedHoverBorder: '#000000',
  switchKnobFill: '#fafafa',
  switchSlideFill: '#000000',
  avatarFill: '#bdbdbd',
  chipDefaultCloseFill: '#000000',
  chipDefaultHoverFill: '#0000001f',
  chipDefaultEnabledBorder: '#bdbdbd',
  chipInfoFilledSubtle: '#DAEDF5',
  chipOnInfoFilledSubtle: '#165071',
  chipErrorFilledSubtle: '#FDEAE7',
  chipOnErrorFilledSubtle: '#4B1815',
  chipOnSuccessFilledSubtle: '#283411',
  chipSuccessFilledSubtle: '#EFFAD2',
  alertErrorContent: '#4b1815',
  alertErrorFill: '#fdeae7',
  alertWarningContent: '#5a2e10',
  alertWarningFill: '#fff0e7',
  alertInfoContent: '#162f40',
  alertInfoFill: '#eaf0f6',
  alertSuccessContent: '#283411',
  alertSuccessFill: '#EFFAD2',
  backdropFill: '#00000080',
  breadcrumbsCollapseFill: '#f5f5f5',
  appbarDefaultFill: '#f5f5f5',
  ratingEnabledBorder: '#0000003b',
  textPrimary: '#333333',
  textSecondary: '#6d6d6d',
  primaryStatesHover: '#84bd000a',
  primaryStatesSelected: '#84bd0014',
  primaryStatesFocus: '#84bd001f',
  primaryStatesFocusVisible: '#84bd004d',
  primaryStatesOutlinedBorder: '#84bd0080',
  secondaryStatesHover: '#0073a50a',
  secondaryStatesSelected: '#0073a514',
  secondaryStatesFocus: '#0073a51f',
  secondaryStatesFocusVisible: '#0073a54d',
  secondaryStatesOutlinedBorder: '#0073a580',
  snackbarDefaultFill: '#121212',

  /* Subscription Tiers backgrounds */
  baseprimaryBg: '#e4dcf7ff',
  basebackupBg: '#f2edfbff',
  advancedprimaryBg: '#cbe4f1ff',
  advancedbackupBg: '#e5f1f8ff',
  complianceprimaryBg: '#dadff6ff',
  compliancebackupBg: '#edeffaff',
  baseplusprimaryBg: '#f5dad0ff',
  baseplusbackupBg: '#faede7ff',
  advancedplusprimaryBg: '#bde2ddff',
  advancedplusbackupBg: '#def1eeff',
  complianceplusprimaryBg: '#efdfb3ff',
  complianceplusbackupBg: '#f8efd9ff',

  /* Subscription Tiers S1 backgrounds */
  subscriptiontierss1BaseprimaryBg: '#e1e1e1ff',
  subscriptiontierss1BasebackupBg: '#ebebebff',
  subscriptiontierss1AdvancedprimaryBg: '#e1e1e1ff',
  subscriptiontierss1AdvancedbackupBg: '#ebebebff',
  subscriptiontierss1PremiumprimaryBg: '#e1e1e1ff',
  subscriptiontierss1PremiumBackupBg: '#ebebebff',
  subscriptiontierss1FipsprimaryBg: '#e1e1e1ff',
  subscriptiontierss1FipsbackupBg: '#ebebebff',

  /* Subscription Tiers borders */
  baseprimaryBorder: '#bca9e9ff',
  basebackupBorder: '#d7cbf2ff',
  advancedprimaryBorder: '#75bcdbff',
  advancedbackupBorder: '#b0d7eaff',
  complianceprimaryBorder: '#a3b1e7ff',
  compliancebackupBorder: '#c8cff1ff',
  baseplusprimaryBorder: '#e1a58cff',
  baseplusbackupBorder: '#efc9b9ff',
  advancedplusprimaryBorder: '#4db6acff',
  advancedplusbackupBorder: '#9bd4cdff',
  complianceplusprimaryBorder: '#ceb140ff',
  complianceplusbackupBorder: '#e5cf8eff',

  /* Subscription Tiers S1 borders */
  subscriptiontierss1BaseprimaryBorder: '#9e9e9eff',
  subscriptiontierss1BasebackupBorder: '#c4c4c4ff',
  subscriptiontierss1AdvancedprimaryBorder: '#9e9e9eff',
  subscriptiontierss1AdvancedbackupBorder: '#c4c4c4ff',
  subscriptiontierss1PremiumpimaryBorder: '#9e9e9eff',
  subscriptiontierss1PremiumpackupBorder: '#c4c4c4ff',
  subscriptiontierss1FipsprimaryBorder: '#9e9e9eff',
  subscriptiontierss1FipsbackupBorder: '#c4c4c4ff',

  /* Subscription Timeline */
  subscriptiontimelinePrimarypastevent: '#85bd00ff',
  subscriptiontimelineBackuppastevent: '#4faad1ff',
  subscriptiontimelineReplacementpastevent: '#26a69aff',

  tooltipBackgroundColor: '#616161',
  tooltipBackgroundOpacity: 0.9,

  backgroundRoleDistributor: '#E1BEE7',
  textOnRoleDistributor: '#311B92',
  backgroundRoleReseller: '#CAE5F1',
  textOnRoleReseller: '#165071',
  backgroundRoleOrgOwner: '#C1DE7F',
  textOnRoleOrgOwner: '#383F28',
};

export default lightTheme;
